<template>
    <fieldset class="order-details co-fieldset">
        <div class="co-fieldset-inner">
            <div class="od-inputs-row">
                <div>
                    <div class="budget-title">
                        Track spend against a budget?
                    </div>
                    <div class="co-fullwidth-input formulate-label-bold">
                        <label
                            ><input
                                type="checkbox"
                                label=""
                                v-model="does_track_budget"
                            />
                            Yes, I would like to keep track of how much I spend
                            on this program against a budget
                        </label>
                    </div>

                    <div v-if="does_track_budget" style="margin-top: 4px">
                        <FormulateInput
                            type="number"
                            label="Budget Amount"
                            class="co-bold-label"
                            placeholder="Enter Budget amount"
                            v-model="budget_amount"
                        />
                    </div>
                </div>
            </div>
            <div class="od-inputs-row">
                <div class="flex">
                    <div>
                        <div>
                            <div class="budget-title">
                                Do orders for this program require a quote
                                first?
                                <span class="required">*</span>
                            </div>
                        </div>
                        <input
                            type="radio"
                            name="gender"
                            :value="true"
                            v-model="quote"
                        />
                        <label>
                            Yes, provide a quote first<br />
                            <input
                                type="radio"
                                name="gender"
                                :value="false"
                                v-model="quote"
                        /></label>
                        <label
                            >No, work on this order can begin immediately,
                            without providing a quote first</label
                        ><br />

                        <div v-if="quote" style="margin-left: 15px">
                            <label for="autoapprove">
                                <input v-model="auto_approve" type="checkbox" />
                                Automatically approve quote if below</label
                            >
                            <FormulateInput
                                type="number"
                                label="Auto Approve Amount"
                                v-model="auto_approve_amount"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </fieldset>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
export default {
    name: "Budget",
    props: {},
    methods: {
        ...mapMutations("CreateProgramStore", [
            "setBudgetAmount",
            "setAutoApprove",
            "setAutoApproveAmount",
            "setQuote",
            "setDoesTrackBudget",
        ]),
    },

    computed: {
        ...mapState({
            formState: (state) => state.CreateProgramStore,
        }),
        budget_amount: {
            get() {
                return this.formState.budget_amount;
            },
            set(value) {
                this.setBudgetAmount(value);
            },
        },
        quote: {
            get() {
                return this.formState.quote;
            },
            set(value) {
                this.setQuote(value);
            },
        },
        auto_approve: {
            get() {
                return this.formState.auto_approve;
            },
            set(value) {
                this.$store.commit("CreateProgramStore/setAutoApprove", value);
            },
        },
        does_track_budget: {
            get() {
                return this.formState.does_track_budget;
            },
            set(value) {
                console.log(value);
                this.$store.commit(
                    "CreateProgramStore/setDoesTrackBudget",
                    value
                );
            },
        },
        auto_approve_amount: {
            get() {
                return this.formState.auto_approve_amount;
            },
            set(value) {
                this.setAutoApproveAmount(value);
            },
        },
    },
    components: {},
};
</script>
